if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          urlInput: this.querySelector('input'),
          shareSummary: this.querySelector('summary'),
          details: this.querySelector('details'),
        };

        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        this.querySelector('.share-button__copy')?.addEventListener('click', () => {
          this.copyToClipboard();
        });

        // Close button
        this.querySelector('.share-button__close')?.addEventListener('click', () => {
          this.closeShareButton();
        });
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value);
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) this.elements.urlInput.value = url;
      }

      closeShareButton() {
        if (this.elements.details) {
          this.elements.details.removeAttribute('open');
          this.elements.shareSummary.setAttribute('aria-expanded', 'false');
        }
      }
    }
  );
}
